import jsPDF from "jspdf"
// import addFont from "../../../../fonts/fonts"
import 'jspdf-autotable'
import moment from "moment"
import addFont from "../../../../../assets/fonts/fonts"
import {htmlToText} from 'html-to-text'
import { MONTH_GENITIVE, MONTH_GENITIVE_NEW } from "../../../../../assets/const"

import mo from '../../../../../assets/images/pdfLogos/MO.png'
import lms from '../../../../../assets/images/pdfLogos/LMS.png'
import guk from '../../../../../assets/images/pdfLogos/GUK.png'
import { getInitials } from "../../../../../utils/smallHelpers"
import { addJustifiedLine } from "../../../../../utils/reportHelpers"

const orientation = 'p'

const COMISSION_HEAD = [
  {position: 'Председатель Аттестационной комиссии Министерства обороны Российской Федерации', value: 'chairman'},
  {position: 'заместитель председателя Аттестационной комиссии Министерства обороны Российской Федерации', value: 'deputy'},
  {position: 'секретарь Аттестационной комиссии Министерства обороны Российской Федерации', value: 'secretary'},
]

export const getProtocolGuk = async ({data, comission, userInfo}) => {

  const {last_name, first_name, patronymic} = userInfo
  const createrName = `${last_name || ''} ${first_name || ''} ${patronymic || ''}`

  const comissionObject = data.experts.reduce((acc, expert) => ({...acc, [expert.place]: expert}), {})
  const comissionMembers = data.experts.filter(i => i.place === 'member')
  
  let lastY = 20
  let actualY
  let text
  let rows

  const getY = (indent, newValue) => {
    let newY = newValue ? newValue + indent : lastY + indent
    if (newY > doc.internal.pageSize.height - 30) {
      doc.addPage('a4', orientation)
      newY = 20
    }
    lastY = newY
    return newY
  }

  const addLogos = () => {
    const pageCount = doc.internal.getNumberOfPages()
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      
      // doc.addImage(guk, 'PNG', 10, 5, 20, 25)
      // doc.addImage(mo, 'PNG', 95, 3, 20, 12)
      // doc.addImage(lms, 'PNG', 190, 285, 15, 9)

      // doc.setFontSize(9)
      // doc.text('Министерство обороны Российской Федерации', 105, 20, 'center')
      // doc.text('Управление военного образования Главного управления кадров', 105, 25, 'center')

      doc.setFontSize(8)
      doc.text(`Кто создал: ${createrName || ''}`, 10, 292)
      doc.text(`Дата: ${moment(comission?.date_to).format('DD.MM.YYYY')}`, 10, 295)
      doc.text(`Лист ${i} из ${pageCount}`, 100, 295, 'center')
      doc.text('Документ сформирован в системе управления обучением', 130, 295)

    }
  }

  const dateFormatted = (date) => moment(date).format(`DD ${MONTH_GENITIVE[moment(date).month()]} YYYY`)
  const dateFormattedNew = (date) => moment(date).format(`${MONTH_GENITIVE_NEW[moment(date).month()]} YYYY`)


  addFont(jsPDF.API)
  const doc = new jsPDF({ putOnlyUsedFonts: true, orientation: orientation })

  doc.setFont('TimesNewRoman')
  doc.setFontSize(13)
  
  
  doc.text('Протокол № ___', 105, lastY, 'center')
  addJustifiedLine(doc, 'заседания Аттестационной комиссии Министерства обороны Российской ', 30, getY(6), 150)
  addJustifiedLine(doc, 'Федерации по аттестации педагогических и руководящих работников ', 30, getY(6), 150)
  addJustifiedLine(doc, 'организаций, осуществляющих образовательную деятельность и ', 30, getY(6), 150)
  addJustifiedLine(doc, 'находящихся в ведении Министерства обороны Российской Федерации, ', 30, getY(6), 150)
  doc.text(`от ${dateFormatted(comission?.date_to)} года`, 105, getY(6), 'center')
  
  doc.setFontSize(12)
  doc.setFont(undefined, 'bold')
  
  doc.text(`Присутствовали:`, 23, getY(14))
  
  doc.setFont(undefined, 'normal')
  
  COMISSION_HEAD.forEach((item, ind) => {
    const {LastName, FirstName, Patronymic, position} = comissionObject[item.value] || {}
    const fio = getInitials(`${LastName || ''} ${FirstName || ''} ${Patronymic || ''}`)
    const text = `          ${item.position} ${fio} - ${position}`
    const rows = doc.splitTextToSize(text, 160)
    const y = ind ? getY(3, actualY) : getY(14)
    actualY = y + rows.length * 5
    doc.text(rows, 23, y)
  })
  
  doc.text(`Члены комиссии:`, 23, getY(2, actualY))
  
  comissionMembers.forEach((expert, ind) => {
    const {LastName, FirstName, Patronymic, position} = expert 
    const fio = getInitials(`${LastName || ''} ${FirstName || ''} ${Patronymic || ''}`)
    const text = `          ${fio} - ${position}`
    const rows = doc.splitTextToSize(text, 160)
    const y = ind ? getY(3, actualY) : getY(10)
    actualY = y + rows.length * 5
    doc.text(rows, 23, y)
  })
  
  doc.setFont(undefined, 'bold')
  doc.text(`Повестка дня:`, 105, getY(10), 'center')
  doc.setFont(undefined, 'normal')

  text = `          1. Рассмотрение аттестационных материалов педагогических и руководящих работников с целью установления первой квалификационной категории в ${dateFormattedNew(comission?.date_to)} года.`
  rows = doc.splitTextToSize(text, 180)
  doc.text(rows, 23, getY(10))

  text = `          2. Рассмотрение аттестационных материалов педагогических и руководящихработников с целью установления высшей квалификационной категории в ${dateFormattedNew(comission?.date_to)} года.`
  rows = doc.splitTextToSize(text, 180)
  doc.text(rows, 23, getY(14))

  doc.setFont(undefined, 'bold')
  doc.text(`Ход заседания:`, 105, getY(14), 'center')
  doc.setFont(undefined, 'normal')
  
  text = '          1. Заслушали секретаря Аттестационной комиссии Министерства обороны Российской Федерации Г.Г.Маркевича по вопросу проведения аттестации педагогических и руководящих работников организаций, осуществляющих образовательную деятельность и находящихся в ведении Министерства обороны Российской Федерации, с целью установления '
  rows = doc.splitTextToSize(text, 180)
  doc.text(rows, 23, getY(10))

  doc.setFont(undefined, 'bold')
  doc.text(`первой квалификационной категории.`, 23, lastY + 19)
  doc.setFont(undefined, 'normal')
  
  text = '          По результатам экспертизы представленных аттестационных материалов считать уровень квалификации следующих педагогических и руководящих работников соответствующим требованиям, предъявляемым к '
  rows = doc.splitTextToSize(text, 180)
  doc.text(rows, 23, getY(25))

  doc.setFont(undefined, 'bold')
  doc.text(`первой квалификационной категории:`, 82, lastY + 9.7)
  doc.setFont(undefined, 'normal')

  const schoolsFCat = Object.keys(data.reasons_statistic_first_category)
  
  schoolsFCat.forEach((school, ind) => {
    doc.setFont(undefined, 'bold')
    const schoolLines = doc.splitTextToSize(school, 180)
    schoolLines.forEach((item, i) => doc.text(item, 105, getY(i ? 6 : ind ? 10 : 25), 'center'))
    doc.setFont(undefined, 'normal')

    data.reasons_statistic_first_category[school].forEach((item, ind) => {
      const fio = `${item.lastName || ''} ${item.firstName || ''} ${item.patronymic || ''}, ${item.position || ''}`
      doc.text(`${ind + 1}. ${fio}`, 23, getY(10))
    })
  })

  const increaseY = schoolsFCat.length ? 10 : 25

  doc.setFont(undefined, 'bold')
  doc.text(`Решение комиссии:`, 105, getY(increaseY), 'center')
  doc.setFont(undefined, 'normal')
  
  text = '          Установить первую квалификационную категорию вышеперечисленным педагогическим работникам организаций, осуществляющих образовательную деятельность и находящихся в ведении Министерства обороны Российской Федерации, по занимаемым должностям.'
  rows = doc.splitTextToSize(text, 180)
  doc.text(rows, 23, getY(10))

  doc.text('Результаты голосования:', 23, getY(17))
  doc.text('«за» – 9', 23, getY(5))
  doc.text('против» – 0', 23, getY(5))


  text = '          2. Заслушали секретаря Аттестационной комиссии Министерства обороны Российской Федерации Г.Г.Маркевича по вопросу проведения аттестации педагогических и руководящих работников организаций, осуществляющих образовательную деятельность и находящихся в ведении Министерства обороны Российской Федерации, с целью установления '
  rows = doc.splitTextToSize(text, 180)
  doc.text(rows, 23, getY(11))

  doc.setFont(undefined, 'bold')
  doc.text(`высшей квалификационной категории.`, 23, lastY + 19)
  doc.setFont(undefined, 'normal')
  
  text = 'По результатам экспертизы представленных аттестационных материалов считать уровень квалификации следующих педагогических и руководящих работников соответствующим требованиям, предъявляемым к '
  rows = doc.splitTextToSize(text, 180)
  doc.text(rows, 23, getY(25))

  doc.setFont(undefined, 'bold')
  doc.text(`высшей квалификационной категории:`, 82, lastY + 9.7)
  doc.setFont(undefined, 'normal')

  const schoolsHCat = Object.keys(data.reasons_statistic_highest_category)

  Object.keys(data.reasons_statistic_highest_category).forEach((school, ind) => {
    doc.setFont(undefined, 'bold')
    const schoolLines = doc.splitTextToSize(school, 180)
    schoolLines.forEach((item, i) => doc.text(item, 105, getY(i ? 6 : ind ? 10 : 25), 'center'))
    doc.setFont(undefined, 'normal')

    data.reasons_statistic_highest_category[school].forEach((item, ind) => {
      const fio = `${item.lastName || ''} ${item.firstName || ''} ${item.patronymic || ''}, ${item.position || ''}`
      doc.text(`${ind + 1}. ${fio}`, 23, getY(10))
    })
  })

  const increaseY2 = schoolsHCat.length ? 10 : 25

  doc.setFont(undefined, 'bold')
  doc.text(`Решение экспертной группы:`, 105, getY(increaseY2), 'center')
  doc.setFont(undefined, 'normal')
  
  text = '          Установить высшую квалификационную категорию вышеперечисленным педагогическим работникам организаций, осуществляющих образовательную деятельность и находящихся в ведении Министерства обороны Российской Федерации, по занимаемым должностям.'
  rows = doc.splitTextToSize(text, 180)
  doc.text(rows, 23, getY(10))

  doc.text('Результаты голосования:', 23, getY(26))
  doc.text('«за» – 9', 23, getY(5))
  doc.text('против» – 0', 23, getY(5))

  COMISSION_HEAD.forEach((item, ind) => {
    const {LastName, FirstName, Patronymic, position} = comissionObject[item.value] || {}
    const fio = getInitials(`${LastName || ''} ${FirstName || ''} ${Patronymic || ''}`)
    const rows = doc.splitTextToSize(item.position, 100)
    const y = ind ? getY(10, actualY) : getY(14)
    actualY = y + rows.length * 5
    doc.text(rows, 23, y)
    doc.text(fio, 180, y + 3, 'right')
  })

  doc.text('Руководитель экспертной группы:', 23, getY(16))
  doc.text('Н.А. Близнова', 180, getY(8), 'right')
  
  doc.text('Члены Аттестационной экспертной', 23, getY(16))
  doc.text('Министерства обороны Российской Федерации', 23, getY(7))
  
  comissionMembers.forEach(item => {
    const fio = getInitials(`${item.LastName || ''} ${item.FirstName || ''} ${item.Patronymic || ''}`)
    doc.text(fio, 180, getY(8), 'right')
  })

  addLogos()

  doc.addPage('a4', orientation)
  doc.deletePage(doc.getNumberOfPages())
  return doc
}